module.exports = __webpack_public_path__ + "static/media/ser_gas_bot_sto.b0ca28f9.png";